


export const hexToRgba = (hex, alpha = 1) => {
    let r, g, b;

    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    } else {
      throw new Error('Invalid HEX color.');
    }
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}